import { Injectable, NgModule } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import {AppConfig} from '../config'
import {AuthService} from './auth.service'

 


@Injectable()
export class SocketUserControl extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketUsersControlUrl,options:{ forceNew:true,             autoConnect: false, 
 
             
            query: {
              token: authService.getToken() || ''    
            },
           
           }});
    }
 }


@Injectable()
export class SocketStreamsControl extends Socket {
    constructor( 
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketStreamsControlUrl,options:{ forceNew:true,             autoConnect: false, 
 // transports: [ "websocket" ],
           
            query: {
              token: authService.getToken() || ''
            }
           }});
    }  

}

@Injectable()
export class SocketStreamsOverview extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketStreamsOverviewUrl,options:{ forceNew:true,             autoConnect: false, 
 // transports: [ "websocket" ],
          
            query: {
              token: authService.getToken() || ''
            }
           }});
    }
  
}  

@Injectable()
export class SocketCdnControl extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketCdnControlUrl,options:{ forceNew:true,             autoConnect: false, 
 // transports: [ "websocket" ],
             
            query: {
              token: authService.getToken() || ''
            },
           
           }});
    }
  
}  

@Injectable()
export class SocketAdminDashboardControl extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketAdminDashboardUrl,options:{ forceNew:true,             autoConnect: false, 
 
             
            query: {
              token: authService.getToken() || ''    
            },
           
           }});
    }
 }


@Injectable()
export class SocketAdminUsersOnlineControl extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketAdminUsersOnlineUrl,options:{ forceNew:true,             autoConnect: false, 
 
             
            query: {
              token: authService.getToken() || ''    
            },
           
           }});
    }
 }






@Injectable()
export class  SocketAdminLogControl extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketAdminLogUrl,options:{ forceNew:true, autoConnect: false, 
 
             
            query: {
              token: authService.getToken() || ''    
            },
           
           }});
    }
 }

@Injectable()  
export class SocketStreamsWatch extends Socket {
    constructor() {
        super({ url: AppConfig.webSocketStreamsWatchUrl,options:{ forceNew:true, autoConnect: false  }});
    }
}



@Injectable()  
export class SocketIncome extends Socket {
    constructor() {
        super({ url: AppConfig.webSocketIncomeControlUrl,options:{ forceNew:true, autoConnect: false  }});
    }
}





@Injectable()  
export class SocketQrEnterWatch extends Socket {
    constructor() {
        super({ url: AppConfig.webSocketQrEnterWatchUrl,options:{ forceNew:true,   autoConnect: false  }});
    }
}





 


@Injectable()
export class SocketStreamsChat extends Socket {
    constructor( 
       private authService: AuthService 
	
    ) {

        
        super({ url: AppConfig.webSocketChatUrl,options:{ forceNew:true, 
            autoConnect: false, 
 // transports: [ "websocket" ],
            query: {
              token: authService?.getToken() || ''
            }
            
           },
            
        });


        //this.ioSocket.io.removeAllListeners()
        //console.log(this)
      //  this.ioSocket.io.autoConnect = false

    }

}


 



@Injectable()
export class SocketRestreamsOverview extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketRestreamsOverviewUrl,options:{ forceNew:true, 
          autoConnect: false, 
 // transports: [ "websocket" ],
            query: {
              token: authService.getToken() || ''
            }
           }});
    }
  
}  



@Injectable()
export class SocketVideosOverview extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketVideosOverviewUrl,options:{ forceNew:true, 
          autoConnect: false, 
 // transports: [ "websocket" ],
            query: {
              token: authService.getToken() || ''
            }
           }});
    }
  
}  


@Injectable()
export class SocketVideosControl extends Socket {
    constructor(
        private authService: AuthService
    ) {
        super({ url: AppConfig.webSocketVideosControlUrl,options:{ forceNew:true, 
         autoConnect: false, 
 // transports: [ "websocket" ],
            query: {
              token: authService.getToken() || ''
            }
           }});
    }
  
}  

export const socketEvents = {
    startTranslation: 'startTranslation',
    stopTranslation: 'stopTranslation',
    streamStarted: 'streamStarted',
    streamStoped: 'streamStoped',
    previewStarted:  'previewStarted',
    previewStoped:  'previewStoped',
    signalConnected: 'signalConnected',
    signalDisconnected: 'signalDisconnected',
    streamStatusChanged: 'streamStatusChanged',
    viewersChanged: 'viewersChanged',
    overviewInitialRunings: 'overviewInitialRunings',
    overviewChangeRunings: 'overviewChangeRunings',
    cdnOnStat: 'cdnOnStat'
}
